import axios from 'axios'
import store from 'store'
import router from '@/router/index'
import { i18n } from 'I18n'
import fileDownload from '@/utils/fileDownload'

const setErrorRoute = async (status) => {
    const route = router.currentRoute.value

    return await router.replace({
        name: status === 404 ? '404' : '500',
        params: { pathMatch: route.path.substring(1).split('/') },
        query: route.query
    })
}

const globalSettings = {
    successMessage: null,
    errorMessage: null,
    successCallback: null,
    errorCallback: null,
    blockUI: false,
    alertOnModal: false,
    token: null,
    download: false
}

const getData = {
    async getData(f, settings, params) {
        if (settings.blockUI) {
            store.dispatch('setDataFetchInProgress', { dataFetchInProgress: true })
        }

        return await f(...params)
            .then(async response => {

                if (settings.download)
                    response.data = await fileDownload(response)

                if (settings.blockUI)
                    store.dispatch('setDataFetchInProgress', { dataFetchInProgress: false })
                else if (response.data.success != null && !response.data.success) {
                    let message = response.data.message ? response.data.message : i18n.t(settings.errorMessage)
                    if (!settings.alertOnModal)
                        store.dispatch('setAlertMessage', { message: message })

                    if (settings.errorCallback && typeof settings.errorCallback === "function")
                        settings.errorCallback(response.data)

                    return
                }

                if (settings.successCallback && typeof settings.successCallback === "function") {
                    if (settings.successMessage)
                        store.dispatch('setSuccessMessage', { message: i18n.t(settings.successMessage) })

                    settings.successCallback(response.data)
                }
            })
            .catch((error) => {
                if (error.response?.status === 401) {
                    window.location.href = '/'
                } else if (!settings.blockUI) {
                    if (settings.errorMessage)
                        store.dispatch('setAlertMessage', { message: i18n.t(settings.errorMessage) })

                    if (settings.errorCallback && typeof settings.errorCallback === "function")
                        settings.errorCallback(error.response)
                } else {
                    setErrorRoute(error.response?.status).then(() => {
                        if (settings.blockUI) {
                            store.dispatch('setDataFetchInProgress', { dataFetchInProgress: false })
                        }
                    })
                }
            })
    },
    async get(url, settings) {
        return this.getData(axios.get, { ...globalSettings, ...settings }, [url])
    },
    async post(url, payload, settings) {
        if (settings.token) {
            axios.defaults.headers.common['X-RequestVerificationToken'] = settings.token
        }

        return this.getData(axios.post, { ...globalSettings, ...settings }, [url, payload])
    },
    async put(url, payload, settings) {
        return this.getData(axios.put, { ...globalSettings, ...settings }, [url, payload])
    },
    async delete(url, settings) {
        return this.getData(axios.delete, { ...globalSettings, ...settings }, [url])
    },
    async download(url, payload, settings) {
        let downloadSettings = { ...globalSettings, ...settings }
        downloadSettings.download = true

        const formData = new URLSearchParams(payload).toString();
        return this.getData(axios.post, downloadSettings, [url, formData, { responseType: 'blob' }])
    },
    async upload(url, payload, settings) {

        // set up the request data
        let formData = new FormData()
        formData.append('file', payload)

        return this.getData(axios.post, { ...globalSettings, ...settings }, [url, formData])
    }
}

export default getData